import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { Image, StyleSheet, TouchableOpacity, TouchableWithoutFeedback, View, useWindowDimensions } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import Svg, { Circle, Path } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useDispatch, useSelector } from "react-redux";
import { useGlobalSearchParams, useLocalSearchParams } from "expo-router";

import BottomSheetModal from "./BottomSheetModal";
import Carousel from "react-native-reanimated-carousel";
import { Colors } from "colors";
import { Images } from "assets";
import VText from "./VText";

export default React.forwardRef((props, ref) => {
    const userProfile = useSelector((state) => state.ProfileReducer.profileData);
    const local = useGlobalSearchParams();
    const gender = local?.gender || "female";
    const { height, width } = useWindowDimensions();
    const _bottomSheetRef = useRef();

    React.useImperativeHandle(ref, () => ({ show }), []);

    const show = () => {
        _bottomSheetRef?.current?.show();
    };

    let [data, setData] = useState([]);

    const [header, setHeader] = useState("");
    const [subHeader, setSubHeader] = useState("");
    const [qrText, setQrText] = useState("");

    useEffect(() => {
        let images = [];

        if (userProfile?.userId && !userProfile?.isGuest) {
            setHeader("Access Your Closet");
            setSubHeader("View your digital closet and start adding new pieces.");
            setQrText("Scan the QR code to download the app.");

            if (gender === "men") {
                images = [
                    Images.mensClosetLogin1,
                    Images.mensClosetLogin2,
                    Images.mensClosetLogin3,
                    Images.mensClosetLogin4,
                    Images.mensClosetLogin5,
                    Images.mensClosetLogin6,
                ];
            } else {
                images = [
                    Images.closetImagesAfterLogin1,
                    Images.closetImagesAfterLogin2,
                    Images.closetImagesAfterLogin3,
                    Images.closetImagesAfterLogin4,
                    Images.closetImagesAfterLogin5,
                    Images.closetImagesAfterLogin6,
                    Images.closetImagesAfterLogin7,
                    Images.closetImagesAfterLogin8,
                ];
            }
        } else {
            setHeader("Build Your Dream Closet");
            setSubHeader(
                "Streamline your wardrobe management: Upload your entire closet and update it in real-time when you shop the newest pieces. With Vêtir, your closet is right at your fingertips. Scan the QR code to download the app."
            );
            setQrText("");

            if (gender === "men") {
                images = [
                    Images.mensClosetGuest1,
                    Images.mensClosetGuest2,
                    Images.mensClosetGuest3,
                    Images.mensClosetGuest4,
                    Images.mensClosetGuest5,
                    Images.mensClosetGuest6,
                ];
            } else {
                images = [
                    Images.closetImagesGuest1,
                    Images.closetImagesGuest2,
                    Images.closetImagesGuest3,
                    Images.closetImagesGuest4,
                    Images.closetImagesGuest5,
                    Images.closetImagesGuest6,
                ];
            }
        }

        setData(images);
    }, [userProfile]);

    return (
        <BottomSheetModal
            MAX_HEIGHT_PERC={1}
            START_PERC={1}
            ref={_bottomSheetRef}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={() => _bottomSheetRef?.current?.hide()}
            >
                <TouchableOpacity
                    style={{
                        width: wp(825),
                        height: "auto",
                        backgroundColor: "#fff",
                        paddingVertical: spV(30),
                        paddingHorizontal: spH(40),
                        overflow: "hidden",
                        cursor: "auto",
                    }}
                    activeOpacity={1}
                >
                    <View style={{ cursor: "" }}>
                        <Carousel
                            loop
                            width={wp(186)}
                            height={hp(250)}
                            style={{ width: wp(186) * 4, pointerEvents: "none", cursor: "none" }}
                            autoPlay={true}
                            autoPlayInterval={2000}
                            scrollEnabled={false} // Disable manual scrolling
                            data={[...data, ...data, ...data]}
                            renderItem={({ item, index }) => (
                                <Image
                                    source={item}
                                    accessibilityLabel={`White Glove Digitization Image ${index + 1}`}
                                    style={{ width: wp(186), height: hp(250), aspectRatio: 290 / 356 }}
                                    resizeMode="cover"
                                />
                            )}
                        />

                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "left",
                                justifyContent: "center",
                                gap: spH(10),
                                marginTop: spV(20),
                            }}
                        >
                            <Image
                                accessibilityLabel="App QR Code"
                                source={Images.appQR}
                                style={{ width: wp(120), height: wp(120) }}
                                resizeMode="cover"
                            ></Image>
                            <View
                                style={{
                                    width: userProfile?.userId && !userProfile?.isGuest ? wp(218) : wp(400),
                                    marginVertical: "auto",
                                }}
                            >
                                <VText style={{ fontSize: fp(24), fontWeight: "700", marginBottom: spV(5) }}>
                                    {header}
                                </VText>
                                <VText style={{ fontSize: fp(16), fontWeight: "300" }}>{subHeader}</VText>
                                <VText style={{ fontSize: fp(16), fontWeight: "300" }}>{qrText}</VText>
                            </View>
                        </View>
                    </View>
                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.white,
        borderRadius: 8,
        width: wp(309),
    },
    image: {
        width: wp(309),
        height: hp(199),
    },
});
